import { Route, Routes } from 'react-router-dom'

import Settings from '../../components/Settings'
import UserManagement from '../../components/Settings/UserManagement'
import ViewUserAccount from '../../components/Settings/ViewUserAccount'
import BillingAndSubscription from '../../components/Settings/Billing'
import OrganizationDetails from '../../components/Settings/OrganizationDetails'
import BusinessHours from '../../components/Settings/BusinessHours'
import StageMapping from '../../components/Settings/StageMapping'
import AppointmentTimeframe from '@forwardflow/components/Settings/AppointmentTimeframe'
import CalendarIntegration from '@forwardflow/components/Settings/CalendarIntegration'
import AppointmentPreferencePage from '@forwardflow/components/Settings/AppointmentPreferencePage'
import Automations from '@forwardflow/components/Settings/Automations'

const SettingsRoutes = () => {
   return (
      <Routes>
         <Route path="" element={<Settings />}>
            <Route path="user-management" element={<UserManagement />}></Route>
            <Route path="user-management/:id" element={<ViewUserAccount />} />
            <Route path="billing" element={<BillingAndSubscription />}></Route>
            <Route
               path="organization-details"
               element={<OrganizationDetails />}
            ></Route>
            <Route path="business-hours" element={<BusinessHours />}></Route>
            <Route
               path="appointment-timeframe"
               element={<AppointmentTimeframe />}
            ></Route>
            <Route path="stage-mapping" element={<StageMapping />}></Route>
            <Route path="integration" element={<CalendarIntegration />}></Route>
            <Route
               path="appointment-preference"
               element={<AppointmentPreferencePage />}
            />
            <Route path="aria" element={<Automations />} />
         </Route>
      </Routes>
   )
}

export default SettingsRoutes
